import { compose, pure, withHandlers, withState } from "recompose";

import { FormattedMessage } from "react-intl";
import NotificationProvider from "../../elements/NotificationContent/Notifications";
import Queries from "../../queries/queries2";
import React from "react";
import Select from "react-select-plus";
import Spinner from "../../elements/Spinner/Spinner";
import TaxSideModalForm from "./TaxSideModalForm";
import _ from "lodash-es";
import { graphql } from "react-apollo";

const sideModalVisible = withState(
  "sideModalVisible",
  "setSideModalVisible",
  false
);

const inputTax = withState("inputTax", "setInputTax", {});

var regex = /[+-]?\d+(\.\d+)?/g;

const notifHandlers = withHandlers({
  sendSuccessCreateNotification: ({ sendNotification }) => () => {
    let notif = NotificationProvider.getSuccessNotification();
    notif.message = <FormattedMessage id="ids_taxHasBeenCreated" />;
    sendNotification && sendNotification(notif);
  },
  sendFailureCreateNotification: ({ sendNotification }) => () => {
    let notif = NotificationProvider.getFailureNotification();
    notif.message = (
      <FormattedMessage id="ids_esendNotificationrrorTaxCouldNotBeCreated" />
    );
    sendNotification && sendNotification(notif);
  }
});

const handlers = withHandlers({
  createTax: ({
    companyId,
    createCompanyTaxMutation,
    setSideModalVisible,
    value,
    multi,
    onSelected,
    sendSuccessCreateNotification,
    sendFailureCreateNotification
  }) => async (label, valuePourcent) => {
    try {
      // trim xx% from label
      const trimmedLabel = label
        .split(regex)[0]
        .trim()
        .toUpperCase();

      // console.log("56 - trimmedLabel=", trimmedLabel);
      // console.log("57 - value=", value);
      // console.log("58 - label=", label);
      // console.log("59 - valuePourcent=", valuePourcent);

      const mutation = await createCompanyTaxMutation({
        variables: {
          companyId,
          label: trimmedLabel !== "" ? trimmedLabel : "TVA",
          valuePourcent,
          active: true
        },
        refetchQueries: [
          {
            query: Queries.GET_ALL_COMPANY_TAXES,
            variables: { companyId }
          }
        ]
      });
      const taxes = mutation.data.updateCompany.taxes;
      console.log(
        "res of createCompanyTaxMutation ",
        mutation.data.updateCompany
      );

      const newTax = {
        value: taxes[taxes.length - 1].id,
        label: `${trimmedLabel} ${taxes[taxes.length - 1].valuePourcent}%`,
        element: taxes[taxes.length - 1]
      };
      multi
        ? value[0]
          ? onSelected([value[0], newTax])
          : onSelected([newTax])
        : onSelected(newTax);


      sendSuccessCreateNotification();
      setSideModalVisible(false);
    } catch (e) {
      console.info("An error occured:", e);
      sendFailureCreateNotification();
    }
  }
});

const TaxSelect = ({
  setInputTax,
  inputTax,
  createTax,
  name,
  value,
  onSelected,
  getAllCompanyTaxes,
  onNewOptionClick,
  sideModalVisible,
  setSideModalVisible,
  forbiddenLabels = [],
  creatable,
  multi,
  showDefaultCheckBox = true
}) => {
  if (getAllCompanyTaxes && getAllCompanyTaxes.loading) {
    return <Spinner size="lg" fullScreen />;
  }
  const Component = creatable ? Select.Creatable : Select;
  let labelsToExclude = multi
    ? value.map(v => {
      return (
        (v.element && v.element.label) || `${v.label} ${v.valuePourcent}%`
      );
    })
    : forbiddenLabels;
  // console.log("getAllCompanyTaxes", getAllCompanyTaxes)

  // actives taxes === active options
  let activeTaxes = [];
  getAllCompanyTaxes.company &&
    getAllCompanyTaxes.company.taxes &&
    getAllCompanyTaxes.company.taxes.map(tax => {
      if (tax.active) {
        return activeTaxes.push({
          label: `${tax.label} ${tax.valuePourcent}%`,
          value: tax.id,
          name: tax.label,
          element: tax
        });
      }
      return true;
    });

  let options = [];

  // filter taxes not matching taxname amoung activeTaxes into options[]
  activeTaxes.map(tax => {
    if (!_.some(labelsToExclude, _.method("includes", tax.name))) {
      return options.push(tax);
    }
    return true;
  });
  // console.log("options", options)

  // rewrite using options values
  const selectedValued = multi
    ? _.map(
      value,
      tax => {
        return _.first(
          // _.some(activeTaxes, _.method("includes", tax.label)));
          // }
          _.filter(activeTaxes, activeTax => {
            return _.includes(
              activeTax.label,
              `${tax.label} ${tax.valuePourcent}%`
            );
          })
        );
      }

      // );
    )
    : // match options using value.id
    _.find(activeTaxes, o => {
      const id = value && value.id !== undefined ? value.id : value;
      return o.value === id;
    });

  return (
    <div>
      <Component
        name={name}
        value={selectedValued}
        onChange={onSelected}
        options={options}
        clearable={!multi}
        multi={multi}
        onNewOptionClick={tax => {
          console.log(tax.value.match(regex));
          setInputTax({
            label:
              (tax && tax.value) ||
              // .split(regex)[0]
              // .trim()
              // .toUpperCase()
              "",
            pourcentValue:
              tax && tax.value.match(regex)
                ? parseFloat(tax.value.match(regex)[0])
                : 0,
            isActive: true
          });
          setSideModalVisible(true);
        }}
      />
      {sideModalVisible ? (
        <FormattedMessage id="ids_registerNewTax">
          {title => (
            <TaxSideModalForm
              title={title}
              options={options}
              tax={inputTax}
              hideMode={true}
              sideModalVisible={true}
              setSideModalVisible={setSideModalVisible}
              onSubmit={createTax}
              showDefaultCheckBox={showDefaultCheckBox}
            />
          )}
        </FormattedMessage>
      ) : (
          <div />
        )}
    </div>
  );
};

export default compose(
  inputTax,
  sideModalVisible,
  graphql(Queries.createCompanyTax, { name: "createCompanyTaxMutation" }),
  notifHandlers,
  handlers,
  graphql(Queries.GET_ALL_COMPANY_TAXES, { name: "getAllCompanyTaxes" }),
  pure
)(TaxSelect);
